export { ReactComponent as RemoveIcon } from '@assets/img/icons/trash.svg';
export { ReactComponent as NotificationIcon } from '@assets/img/icons/icon-notifications.svg';
export { ReactComponent as AnimatedSpinnerIcon } from '@assets/img/icons/animated-spinner-icon.svg';
export { ReactComponent as MessageIcon } from '@assets/img/icons/icon-message.svg';
export { default as FolderIcon } from '@assets/img/icons/folder-icon.svg';
